import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./styles.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
import AboutCard from "Components/AboutUs/Cards/Cards";
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>ITIN Application (W-7) Services</h3>
                </header>

                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <h3>Do you need an ITIN for tax purposes?</h3>
                        <p>
                            At Serene Tax, we make the ITIN (Individual Taxpayer
                            Identification Number) application process simple
                            and efficient. Whether you're a non-resident alien,
                            dependent, or spouse who isn't eligible for a Social
                            Security Number (SSN), we can assist you in
                            obtaining an ITIN so you can comply with U.S. tax
                            laws
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>

                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About_2} alt="user" />
                    <div className={AboutClasses["content"]}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>What is an ITIN?</h3>
                        <p>
                            An Individual Taxpayer Identification Number (ITIN)
                            is a unique, nine-digit number issued by the IRS for
                            tax purposes. It is used for individuals who are not
                            eligible for a Social Security Number (SSN) but need
                            to file a U.S. tax return, such as non-resident
                            aliens, dependents, and spouses.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Why Do You Need an ITIN?</h3>
                        <ul>
                            <li>
                                <b> Filing U.S. Taxes:</b> If you need to file a
                                tax return but don't have an SSN, an ITIN is
                                required to ensure your return is processed.
                            </li>
                            <li>
                                <b>Claiming Tax Benefits:</b> Many tax credits,
                                including the Child Tax Credit and the Earned
                                Income Tax Credit, require an ITIN for
                                eligibility.
                            </li>
                            <li>
                                <b>Opening a U.S. Bank Account:</b>Some
                                financial institutions may require an ITIN to
                                open an account.
                            </li>
                            <li>
                                <b>Other Legal and Financial Purposes:</b>An
                                ITIN can also be used for other transactions
                                that require taxpayer identification, such as
                                applying for a loan or mortgage.
                            </li>
                        </ul>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Who Needs to Apply for an ITIN?</h3>
                        <ul>
                            <li>
                                Non-resident aliens who are required to file a
                                U.S. tax return.
                            </li>
                            <li>
                                U.S. resident aliens who are not eligible for an
                                SSN.
                            </li>
                            <li>
                                Dependents or spouses of U.S. citizens or
                                resident aliens who need to be claimed on a tax
                                return.
                            </li>
                            <li>
                                Foreign investors who need to comply with U.S.
                                tax reporting requirements.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>How to Apply for an ITIN (Form W-7)</h3>
                        <p>
                            Applying for an ITIN can be a straightforward
                            process when done with the right assistance. Here’s
                            how we can help:
                        </p>
                        <ul>
                            <li>
                                <b> Complete Form W-7:</b> We’ll guide you
                                through completing the IRS Form W-7, the
                                application form required to obtain an ITIN.
                            </li>
                            <li>
                                <b>Provide Documentation:</b> We will assist you
                                in gathering the necessary documents, such as a
                                passport, visa, or other supporting
                                identification, to verify your identity and
                                foreign status.
                            </li>
                            <li>
                                <b>Submit to the IRS:</b>Once the form and
                                documentation are ready, we will provide set of
                                documents to submit your application directly to
                                the IRS to ensure proper processing.
                            </li>
                            <li>
                                <b>Receive Your ITIN:</b>After processing
                                (typically 7-11 weeks), you will receive your
                                ITIN directly from the IRS. We’ll notify you as
                                soon as it arrives.
                            </li>
                        </ul>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>
                            Why Choose Serene Tax for Your ITIN Application?
                        </h3>
                        <ul>
                            <li>
                                <b>Expert Guidance:</b> Our experienced team of
                                tax professionals will ensure your ITIN
                                application is completed accurately and
                                efficiently
                            </li>
                            <li>
                                <b>Time-Saving Process:</b> Navigating the ITIN
                                application process can be complicated, but we
                                handle the paperwork for you, saving you time
                                and potential confusion.
                            </li>
                            <li>
                                <b>Personalized Service:</b> We take the time to
                                understand your specific situation and provide
                                you with tailored assistance.
                            </li>
                            <li>
                                <b>IRS Authorized Acceptance Agent:</b> Serene
                                Tax is an IRS-authorized Certifying Acceptance
                                Agent, meaning we can verify your documents and
                                submit your application directly to the IRS.
                            </li>
                        </ul>
                    </div>
                </div>
                <div
                    className={AboutClasses["section-1"]}
                    style={{ gridTemplateColumns: "1fr" }}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Common Questions About ITINs</h3>
                        <h4>1. How long does it take to get an ITIN?</h4>
                        <p>
                            Typically, it takes 7-11 weeks for the IRS to
                            process your ITIN application. However, this
                            timeframe can vary based on the complexity of your
                            case and the IRS workload.
                        </p>
                        <h4>
                            2. Can I use my ITIN to apply for a Social Security
                            Number (SSN)?
                        </h4>
                        <p>
                            No. An ITIN is only for tax purposes and cannot be
                            used to apply for an SSN. If you are eligible for an
                            SSN, you must apply separately through the Social
                            Security Administration.
                        </p>
                        <h4>
                            3. Do I need an ITIN if I am a foreign national and
                            not earning income in the U.S.?
                        </h4>
                        <p>
                            If you need to file a U.S. tax return or are listed
                            as a dependent or spouse on a tax return, you may
                            need an ITIN even if you don’t earn income in the
                            U.S.
                        </p>
                        <h3>Ready to Apply for Your ITIN?</h3>
                        <p>
                            If you need an ITIN to file your taxes or claim tax
                            benefits, Serene Tax is here to help! We make the
                            application process straightforward and hassle-free,
                            ensuring you have all the documentation needed for
                            approval. Contact us today to start your ITIN
                            application.{" "}
                            <b>Call [+1 (262) 735-8874/ +1 (262) 735- 8875]</b>
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default About;
